import { numberSeparatorMap } from '@databases/collab/convert/to-collab';
import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setFieldSettingsSeparatorField: YJSChangeHandler<
  DatabaseChangeType.SET_FIELD_SETTINGS_SEPARATOR_FIELD
> = ({ ydb, change }) => {
  ydb.mutate((db) => {
    if (change.changeType === 'decimalSeparator') {
      if (change.newValue === undefined) {
        return;
      }

      db.fieldsById[change.fieldId].customNumberFormat.decimalSeparator =
        numberSeparatorMap[change.newValue];
    } else if (change.changeType === 'thousandsSeparator') {
      db.fieldsById[change.fieldId].customNumberFormat.thousandsSeparator =
        change.newValue ? numberSeparatorMap[change.newValue] : undefined;
    }
  });
};
